import type { Namespace, TFunction } from 'i18next';
import type { InsInsightOutcomeDTO } from '../../../server/dto/ins-insight-outcome-dto.ts';
import type { InsightListItem } from '../../../server/types/infer-trpc-types.ts';

/**
 * Display name for what an insight is about — the product category for most types.
 *
 * An insight actionable on the customer itself (`GlobalChurnWarning`) has no category, and
 * `actionable_entity_id` there is the customer id, so falling back to it would print a raw id
 * where a category name belongs. Those render the cross-category label instead (RETAIN-813).
 *
 * Both helpers below key off `actionable_entity_type` rather than the presence of the category
 * object, so they encode the same rule whichever DTO they are handed.
 */
export function getInsightEntityName(t: TFunction<Namespace>, insightItem: InsightListItem): string {
    const { insight, details } = insightItem;

    if (insight.actionable_entity_type !== 'WEB_CATEGORY') {
        return t('insight_entity__multiple_categories', { ns: 'insights' });
    }

    return details.category?.title ?? insight.actionable_entity_id;
}

/** Same rule for a resolved outcome. */
export function getInsightOutcomeEntityName(t: TFunction<Namespace>, outcome: InsInsightOutcomeDTO): string {
    if (outcome.insight.actionable_entity_type !== 'WEB_CATEGORY') {
        return t('insight_entity__multiple_categories', { ns: 'insights' });
    }

    return outcome.category?.name ?? outcome.insight.actionable_entity_id;
}
